import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70916163"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "password-forgotten-form password-form-weblib",
  "data-qe-id": "form-password-forgotten"
}
const _hoisted_2 = {
  key: 0,
  class: "form-message form-error"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icf-warning" }, null, -1))
const _hoisted_4 = { class: "form-group-child" }

import PasswordInput from '@/components/PasswordInput.vue'
import PasswordRepeatInput from '@/components/PasswordRepeatInput.vue'
import { Password, PasswordRepeat } from '@/model/Password'
import { ERROR_CODES } from '@/model/ERROR_CODES'
import { Ref, onMounted, ref } from 'vue'
import { setupComponentI18n } from '@gd/i18n'

interface Props {
  appName?: GD_playerProfile.AppName
  platform?: GD_playerProfile.Platform
  colorScheme?: string
}

const passwordUrl = '/gd/rest/playerProfile/newPassword'

export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordForgottenForm',
  props: {
    appName: {},
    platform: {},
    colorScheme: { default: 'midBlue' }
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

setupComponentI18n()

const props = __props

const emit = __emit

// /gd/playerProfile/newPassword.xhtml?cn=flip&id=4fcc48736a3ac3d39cfcf5c545852883a7db5c1f89c95604bb65753b75c0&forceLogin=true&s=nlsyspwd&lid=h1
const userName = ref('')
const hiddenToken = ref('')
const errorCode: Ref<'main' | 'invalidToken' | ''> = ref('')

onMounted(() => {
  const t = new URLSearchParams(location.search)
  userName.value = t.get('cn')
  hiddenToken.value = t.get('id')
  errorCode.value = ''
})

const passwordRepeat: Ref<PasswordRepeat> = ref({
  value: '',
  valid: false,
  errorCode: undefined,
  length: false,
  identically: false,
})

const password: Ref<Password> = ref({
  value: '',
  valid: false,
  errorCode: undefined,
  length: false,
  numbers: false,
  specialChars: false,
  lowerUpperCase: false,
  scoreOk: false,
  sameAsOldPassword: true,
  sameAsUserName: true,
  similarToUserName: false,
  sameAsEmail: false,
  score: 0,
})
const enablePasswordRepeatValidation = ref(false)
const enablePasswordValidation = ref(false)

const buttonProgress = ref(false)

const action = () => {
  // this.password = validatePassword(this.password.value, this.name.value)
  enablePasswordValidation.value = true
  enablePasswordRepeatValidation.value = true

  if (password.value.valid && passwordRepeat.value.valid) {
    buttonProgress.value = true
    const requestData: GD_playerProfile.NewPasswordData = {
      hiddenToken: hiddenToken.value,
      hiddenCommonName: userName.value,
      passwordInput: password.value.value,
      passwordRepeatInput: passwordRepeat.value.value,
      ...(props.platform && { platform: props.platform }),
      ...(props.appName && { appName: props.appName }),
    }

    fetch(passwordUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    })
      .then((res) => res.json())
      .then((response: GD_playerProfile.NewPasswordResponse) => {
        if (response.errors && response.errors.length > 0) {
          if (response.errors.indexOf('unknownError') > -1) {
            errorCode.value = 'main'
          }
          if (response.errors.indexOf('passwordSameAsCurrent') > -1) {
            password.value.errorCode = ERROR_CODES.passwordEqualsPassword
          }
          if (response.errors.indexOf('passwordInvalidFormat') > -1) {
            password.value.errorCode = ERROR_CODES.passInvalid
          }
          if (response.errors.indexOf('passwordEqualsCommonName') > -1) {
            password.value.errorCode = ERROR_CODES.passEqualsName
          }
          if (response.errors.indexOf('passwordSimilarCommonName') > -1) {
            password.value.errorCode = ERROR_CODES.passSimilarName
          }
          if (response.errors.indexOf('passwordEqualsEmail') > -1) {
            password.value.errorCode = ERROR_CODES.passwordEqualsEmail
          }
          if (response.errors.indexOf('invalidToken') > -1) {
            errorCode.value = 'invalidToken'
          }
          buttonProgress.value = false
        } else {
          if (process.env.VUE_APP_BUILD_TARGET !== 'common') {
            if (response.redirectUrl) {
              window.location.href = response.redirectUrl
            } else {
              // TODO: Evaluate whether this case can ever happen ?
              password.value.value = ''
              passwordRepeat.value.value = ''
              enablePasswordValidation.value = false
              buttonProgress.value = false
            }
          } else {
            emit('success', {
              name: userName.value,
              pwHash: response.pwHash,
            })
          }
        }
      })
      .catch(() => {
        buttonProgress.value = false
      })
  }
}

const preventSubmit = (event: Event) => {
  event.preventDefault()
  event.stopPropagation()
}

return (_ctx: any,_cache: any) => {
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "form-gouping",
      onSubmit: _withModifiers(action, ["prevent"])
    }, [
      _createVNode(PasswordInput, {
        modelValue: password.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
        name: userName.value,
        validate: enablePasswordValidation.value,
        onReset: _cache[1] || (_cache[1] = ($event: any) => (enablePasswordValidation.value = false)),
        newPasswordText: true
      }, null, 8, ["modelValue", "name", "validate"]),
      _createVNode(PasswordRepeatInput, {
        modelValue: passwordRepeat.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordRepeat).value = $event)),
        password: password.value.value,
        validate: enablePasswordRepeatValidation.value,
        onReset: _cache[3] || (_cache[3] = ($event: any) => (enablePasswordRepeatValidation.value = false))
      }, null, 8, ["modelValue", "password", "validate"]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (errorCode.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`pfwPasswordForgotten.error.${errorCode.value}`)), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "t-button-group",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (preventSubmit($event)))
        }, [
          _createVNode(_component_t_button, {
            onClick: action,
            progress: buttonProgress.value,
            color: _ctx.colorScheme,
            complementary: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('pfwPasswordForgotten.main.button')), 1)
            ]),
            _: 1
          }, 8, ["progress", "color"])
        ])
      ])
    ], 32)
  ]))
}
}

})